<template>
  <div class="calendar_container">
    <div class="m-row">
      <p :class="{'err_message': minRangeNotMet}">{{minRangeMessage}}</p>
    </div>
    <div class="m-row">
      <div class="m-col 3 date_nav back">
        <div @click="incrementYear(-1)"><md-icon >skip_previous</md-icon></div>
      </div>
      <div class="m-col 3 date_nav back">
        <div @click="incrementMonth(-1)"><md-icon >keyboard_arrow_left</md-icon></div>
      </div>
      <div class="m-col 6 date_nav">
        <p class="date_nav year"><span class="month">{{getMonthText(selectedMonthStart)}}</span><br> {{selectedYearStart}}</p>
      </div>
      <div class="m-col 3 date_nav forward">
        <div @click="incrementMonth(1)"><md-icon >keyboard_arrow_right</md-icon></div>
      </div>
      <div class="m-col 3 date_nav forward">
        <div @click="incrementYear(1)"><md-icon >skip_next</md-icon></div>
      </div>  
    </div>


    <div class="cal-table-container">
      <div class="m-row mt-3">
        <div class="m-col calendar_day weekday_index" v-for="(d) in weekdays" :key="d.id">{{d.value}}</div>
      </div>
      <div v-for="(week, index) in weeksStart" :key="week[0] + index" class="m-row">
        <div
          class="m-col calendar_day"
          v-for="(day, index) in week"
          :key="day.id + index"
          :class="{
            selected_day: isDaySelected(day),
            in_between_day: isDayInBetween(day),
            
          }"
        >
          <div v-if="isDayEmpty(day)"></div>
          <div v-else class="day_value_holder" @click="selectDay(day)" :class="{start: isStartDay(day, true), end: isEndDay(day, true), is_disabled_day: isDayDisabled(day)}">{{ day.value }}</div>
        </div>
      </div>
    </div>
    <div class="m-row mt-3" v-if="startDateSelectedTitle">
      <div class="m-col">{{startDateSelectedTitle}}<br>
        <div class="dateSelectedTitleValue">
          <p v-if="selectedDayStart.id">{{convertDayToDate(selectedDayStart)}}</p>
          <p v-else style="font-size: 0.7em">{{i18n_local.select_date_or_range}}</p>
        </div>
      </div>
      <div class="m-col">{{endDateSelectedTitle}}<br>
        <div class="dateSelectedTitleValue">
          <p v-if="selectedDayEnd.id">{{convertDayToDate(selectedDayEnd)}}</p>
          <p v-else style="font-size: 0.7em">{{i18n_local.select_date_or_range}}</p>
        </div>
      </div>
    </div>

    <div class="m-row mt-5" v-if="showActionBar">
      <div class="m-col">
        <moow-button :type="['dark', 'outlined', 'flat']" btnText="Clear" @mClick="clearSelectedDays()" :disabled="disableClear"/>
      </div>
      <div class="m-col ml-2">
        <moow-button :type="['light']" btnText="Next" @mClick="next()" :disabled="disableNext" :tooltip="i18n_local.select_date_or_range"/>
      </div>
    </div>
    <div class="m-row mt-2" v-if="actionButtonTitle">
      <div class="m-col">
        <moow-button :type="['dark', 'link']" :btnText="actionButtonTitle" @mClick="actionButtonClick()" style="text-align:center"/>
      </div>
    </div>

  </div>
</template>

<script>
import dayjs from "dayjs"
const lists = require("@/lists.js");
import { mapGetters } from "vuex";

export default {
  props: {
    // disabledDates: {
    //   type: Function,
    //   required: false,
    // },
    disabledDates: {
      type: Function,
      required: false,
    },
    maxDateRangeInDays: {
      type: Number,
      required: false,
    },
    minRangeMessage: {
      type: String, 
      required: false
    },
    minDateRangeInDays: {
      type: Number,
      required: false,
    },
    startDateSelectedTitle: {
      type: String,
      default: "Moving in"
    },
    endDateSelectedTitle: {
      type: String,
      default: "Moving out"
    },
    showActionBar: {
      type: Boolean,
      default: true
    },
    actionButtonTitle: {
      type: String, 
      required: false
    }
  },
  components: {},
  data() {
    return {
      weekdays: [
        {value: "Mo", id: "monday1"},
        {value: "Tu", id: "tuesday1"},
        {value: "We", id: "wednesday1"},
        {value: "Th", id: "thursday1"},
        {value: "Fr", id: "friday1"},
        {value: "Sa", id: "saturday1"},
        {value: "Su", id: "sunday1"}
      ],
      months: [
        {
          value: "0",
          text: "January",
        },
        {
          value: "1",
          text: "February",
        },
        {
          value: "2",
          text: "March",
        },
        {
          value: "3",
          text: "April",
        },
        {
          value: "4",
          text: "May",
        },
        {
          value: "5",
          text: "June",
        },
        {
          value: "6",
          text: "July",
        },
        {
          value: "7",
          text: "August",
        },
        {
          value: "8",
          text: "September",
        },
        {
          value: "9",
          text: "October",
        },
        {
          value: "10",
          text: "November",
        },
        {
          value: "11",
          text: "December",
        },
      ],
      minYear: 1990,
      maxYear: 2500,
      years: [],
      selectedYearStart: undefined,
      selectedYearEnd: undefined,
      selectedMonthStart: undefined,
      selectedMonthEnd: undefined,
      selectedDayStart: { id: undefined },
      selectedDayEnd: { id: undefined },
      currentYear: undefined,
      currentMonth: undefined,
      currentDay: undefined,
      weeksStart: [],
      minRangeNotMet: false
      // maxDayEnd: undefined
    };
  },
  computed: {
    ...mapGetters("internationalizationModule", ["i18n_local"]),
    maxDayEndExc(){
      if(!this.selectedDayStart.id) return false
      else {
        const nextBlockedDate = this.getNextBlockedDate(this.selectedDayStart)
        if(nextBlockedDate) return nextBlockedDate
        return false
      }
    },
    minDayEndExc(){
      if(!this.selectedDayStart.id) return false
      else return dayjs(new Date(this.selectedDayStart.year, this.selectedDayStart.month, this.selectedDayStart.day))
    },
    disableNext(){
      let res = false
      if(!this.selectedDayStart.id) res = true
      if(this.minDateRangeInDays && this.selectedDayEnd.id){
        const diffTime = Math.abs(new Date(this.selectedDayEnd.year, this.selectedDayEnd.month, this.selectedDayEnd.day) - new Date(this.selectedDayStart.year, this.selectedDayStart.month, this.selectedDayStart.day));
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 
        if(diffDays+1 < this.minDateRangeInDays){
          res = true
          this.minRangeNotMet = true
        } 
      }
      return res
    },
    disableClear(){
      if(!this.selectedDayStart.id) return true
      return false
    }
  },
  watch: {
    selectedYearStart(val, oldVal){
      this.setDaySelection(this.selectedMonthStart, val)
    },
    selectedMonthStart(){
      this.setDaySelection(this.selectedMonthStart, this.selectedYearStart)
    }
  },
  created() {
    this.setYearSelection();
    this.setMonthSelection();
  },
  methods: {
    actionButtonClick(){
      this.$emit("emitActionButton")
    },
    next(){
      if(!this.selectedDayStart) return
      let start = new Date(this.selectedDayStart.year, this.selectedDayStart.month, this.selectedDayStart.day)
      let end
      if(this.selectedDayEnd) end = new Date(this.selectedDayEnd.year, this.selectedDayEnd.month, this.selectedDayEnd.day)
      this.$emit("emitDatesSelected", {startDate:start, endDate: end})
    },
    clearSelectedDays(){
      this.selectedDayStart = { id: undefined }
      this.selectedDayEnd = { id: undefined }
    },
    getMonthText(monthValue){
      return lists.monthList[monthValue]
    },
    incrementYear(howMuch){
      let newYearValue = this.selectedYearStart + howMuch 
      if(newYearValue < this.minYear) newYearValue = this.maxYear
      else if(newYearValue >  this.maxYear) newYearValue = this.minYear
      this.selectedYearStart = newYearValue
    },
    incrementMonth(howMuch){
      let newMonthValue = this.selectedMonthStart + howMuch
      
      if(newMonthValue < 0) newMonthValue = 11
      else if(newMonthValue > 11) newMonthValue = 0
      this.selectedMonthStart = newMonthValue
    },
    isStartDay(day, applyStyling){
      if(applyStyling && !this.selectedDayEnd.id) return false // if end date is not selected we don't want to set styling meant for start day
      return this.selectedDayStart.id === day.id
    },
    isEndDay(day, applyStyling){
      return this.selectedDayEnd.id === day.id
    },
    isDayEmpty(day){
      return day.empty
    },
    convertDayToDate(day, format){
      if(!day) return undefined
      let d = dayjs(new Date(day.year, day.month, day.day))
      if(format) return d.format(format)
      else return d.format("DD MMM YYYY")
    },
    isDayDisabled(day) {
      let result = false
      if(this.isDayEmpty(day)) result = true
      else{
        const asDate = dayjs(new Date(day.year, day.month, day.day))
        if(this.isDateDisabled(asDate)) result = true
        if(this.maxDayEndExc && this.selectedDayStart && !asDate.isBefore(this.maxDayEndExc)) result = true
        if(this.minDayEndExc && this.selectedDayStart && asDate.isBefore(this.minDayEndExc)) result = true
      } 
      if(result) day.disabled = true  
      return result
    },
    isDateDisabled(date){
      if(this.disabledDates) return this.disabledDates(date);
      return false
    },
    // isEndDateDisabled(date){
    //   if(this.disabledEndDates) return this.disabledEndDates(new Date(day.year, day.month, day.day));
    //   else return false
    // },
    isDaySelected(day) {
      if(this.isDayEmpty(day)) return false
      if (this.selectedDayStart.id === day.id) return true;
      if (this.selectedDayEnd.id === day.id) return true;
      return false;
    },
    isDayInBetween(day) {
      try {
      if(this.isDayEmpty(day)) return false
        if (!this.selectedDayEnd.id) return false;
        return (
          this.isDayAfterSelectedStart(day) && this.isDayBeforeSelectedEnd(day)
        );
      } catch (error) {
        return false;
      }
    },
    isDayAfterSelectedStart(day) {
      if (this.selectedDayStart.year === day.year) {
        if (this.selectedDayStart.month === day.month) {
          return this.selectedDayStart.day < day.day;
        }
        if (this.selectedDayStart.month < day.month) return true;
        else return false;
      }
      if (this.selectedDayStart.year < day.year) return true;
      else return false;
    },
    isDayBeforeSelectedEnd(day) {
      if (this.selectedDayEnd.year === day.year) {
        if (this.selectedDayEnd.month === day.month) {
          return this.selectedDayEnd.day > day.day;
        }
        if (this.selectedDayEnd.month > day.month) return true;
        else return false;
      }
      if (this.selectedDayEnd.year > day.year) return true;
      else return false;
    },
    selectDay(day) {
      if(this.isDayDisabled(day)) {
        this.clearSelectedDays()

        return
      }
      if (this.selectedDayEnd.id || !this.selectedDayStart.id) {
        this.selectedDayStart = day;
        this.selectedDayEnd = { id: undefined };
      } else {
        this.minRangeNotMet = false
        this.selectedDayEnd = day;
      } 
    },
    setYearSelection() {
      this.currentYear = dayjs().year();
      this.selectedYearStart = dayjs().year();
      var yearBox = document.getElementById("year_start");
      for (let i = this.minYear; i < this.maxYear; i++) {
        this.years.push({ text: i, value: i });
      }
    },
    setMonthSelection() {
      this.currentMonth = dayjs().month();
      this.selectedMonthStart = dayjs().month();
    },
    setDaySelection(month, year){
      if(isNaN(month) || isNaN(year)) return
      this.weeksStart = this.getWeeksInMonth(month, year);
    },
    getWeeksInMonth(month, year) {      
      var weeks = [],
      firstDate = new Date(year, month, 1),
      lastDate = new Date(year, month + 1, 0),
      numDays = lastDate.getDate();

      var start = 1;
      var end = 7 - firstDate.getDay();

      if (firstDate.getDay() === 0) {
        end = 1;
      } else {
        end = 7 - firstDate.getDay() + 1;
      }
      while (start <= numDays) {
        const thisWeekDays = this.getThisWeekDays(start, end, month, year);
        weeks.push(thisWeekDays);
        // weeks.push({start, end});
        start = end + 1;
        end = end + 7;
        end = start === 1 && end === 8 ? 1 : end;
        if (end > numDays) end = numDays;
      }
      return weeks;
    },
    getThisWeekDays(startDay, endDate, month, year) {
      let days = [];
      let emptyDaysInWeek = 7 - (endDate-startDay) - 1

      if(emptyDaysInWeek > 0){
        for (let k = 0; k < emptyDaysInWeek; k++) {
          days.push({
            id:k+Math.random(),
            value: 0,
            empty: true
          });
        }
      }
      for (let i = startDay; i <= endDate; i++) {
        days.push({
          value: i,
          id: i + lists.monthList[month] + year,
          month: month,
          year: year,
          day: i,
        });
      }
      return days;
    },
    getNextBlockedDate(fromThisDay){
      let fromThisDate = dayjs(new Date(fromThisDay.year, fromThisDay.month, fromThisDay.day))
      // search from the next 360 days
      let nextDate = fromThisDate.add(1, 'day')
      for (let i = 0; i < 360; i++) {
        if(this.maxDateRangeInDays && i === this.maxDateRangeInDays-1) return nextDate 
        else if(this.isDateDisabled(nextDate)) return nextDate
        else nextDate = nextDate.add(1, 'day')
      }
      return false
    }
  },
};
</script>
<style scoped lang="scss">
@import "../../../assets/styles/global.css";
@import "../../../assets/styles/variables.scss";

.cal-table-container{
  min-height: 285px;
}

.calendar_container{
  max-width: 400px;
  text-align: center;
  padding: 1em;
  background-color: white;
}

.datepicker_container{
  margin:0 auto;
}

.day_value_holder{
  border-radius: 50px;
  padding: 0.6em;
  font-size: 20px;
  color: $scuffed-dark-grey;
}




.day_value_holder.end{
  border-radius: 0px 50px 50px 0px;
}

.day_value_holder.start{
  border-radius: 50px 0px 0px 50px;
}

.day_value_holder:not(.is_disabled_day):hover {
  background-color: $old-makeup-pink;
  color: white;
  opacity: 0.9;
  cursor: pointer;
}

.calendar_day {
  width: 50px;
  text-align: center;
}

.selected_day > .day_value_holder {
  color: white;
  background-color: $old-makeup-pink;
}

.in_between_day, .in_between_day > .day_value_holder{
  color: white;
  background-color: $old-makeup-pink;
  opacity: 0.9;
  border-radius: 0;
}

.weekday_index{
  color: grey;
  font-size: 1.2em;
}

.is_disabled_day{
  opacity: 0.6;
  cursor: not-allowed;
}

.m-row{
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
}

.m-col{
  display: flex;
  flex-direction: column;
  flex-basis: 100%;
  flex: 1;
}

.date_nav{
  cursor: pointer;
  text-align: center;  
  margin: 0 auto;
}

// .date_nav .year{
//   text-align: center;
//   font-size: 1.2em;
// }

.date_nav .month, .dateSelectedTitleValue{
  text-align: center;
  font-size: 1.3em;
}

.err_message{
  font-weight: bold;
  color: $old-makeup-pink;
}

  /*  This kicks in from 800px and less*/
  @media (max-width: 800px) {
    .day_value_holder{
      font-size: 16px;
    }

    .cal-table-container{
      min-height: 185px;
    }
  }


</style>



// WEBPACK FOOTER //
// src/components/interface/datetime/BaseDatePicker.vue